// SPDX-License-Identifier: AGPL-3.0-or-later

// LOCAL-ONLY: the target's "Bumped by <name>" banner above the new-messages bar (bump-plan.md sections 1 and 3), for
// the open channel while ChannelBumps holds its banner (until the channel switch). The name: the bumper's display
// name, else username, else "Someone" (no fetch). Exclude from upstream sync.

import {BumpStrings, bumpedByText} from '@app/features/bump/BumpStrings';
import styles from '@app/features/bump/components/BumpedBanner.module.css';
import ChannelBumps from '@app/features/bump/state/ChannelBumps';
import Users from '@app/features/user/state/Users';
import {HandWavingIcon} from '@phosphor-icons/react';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';

export function bumperName(userId: string): string {
	const user = Users.getUser(userId);
	return user?.globalName || user?.username || BumpStrings.someone;
}

export const BumpedBanner = observer(({channelId, belowBar}: {channelId: string; belowBar: boolean}) => {
	const banner = ChannelBumps.bannerFor(channelId);
	if (banner == null) return null;
	return (
		<div className={clsx(styles.banner, belowBar && styles.belowBar)} role="status" data-flx="bump.bumped-banner">
			<HandWavingIcon className={styles.icon} weight="fill" aria-hidden data-flx="bump.bumped-banner.icon" />
			<span className={styles.text} data-flx="bump.bumped-banner.text">
				{bumpedByText(bumperName(banner.bumped_by))}
			</span>
		</div>
	);
});
